/* ============================================================
   PrintLegacy Sale — shared JS (scroll reveal + countdown registry)
   Safe to load once on any page.
============================================================ */
(function(){
  "use strict";

  /* Scroll reveal for any .pl-s__reveal added to the DOM */
  function initReveal(){
    var els=document.querySelectorAll(".pl-s__reveal:not(.pl-bound)");
    if(!("IntersectionObserver" in window)){
      Array.prototype.forEach.call(els,function(e){e.classList.add("pl-in","pl-bound");});return;
    }
    var io=new IntersectionObserver(function(es){
      es.forEach(function(en){if(en.isIntersecting){en.target.classList.add("pl-in");io.unobserve(en.target);}});
    },{threshold:.12});
    Array.prototype.forEach.call(els,function(e){e.classList.add("pl-bound");io.observe(e);});
  }

  /* Countdown: any element with data-pl-countdown="ISO_DATE" gets its
     [data-d][data-h][data-m][data-s] children updated every second. */
  function pad(n){return n<10?"0"+n:""+n;}
  function initCountdowns(){
    var boxes=document.querySelectorAll("[data-pl-countdown]:not(.pl-cd-bound)");
    Array.prototype.forEach.call(boxes,function(box){
      box.classList.add("pl-cd-bound");
      var end=new Date(box.getAttribute("data-pl-countdown")).getTime();
      var expired=box.getAttribute("data-pl-expired")||"Ends soon!";
      var d=box.querySelector("[data-d]"),h=box.querySelector("[data-h]"),
          m=box.querySelector("[data-m]"),s=box.querySelector("[data-s]");
      function tick(){
        var diff=end-Date.now();
        if(diff<=0){if(d)d.textContent="00";if(h)h.textContent="00";if(m)m.textContent="00";if(s)s.textContent="00";
          if(box.hasAttribute("data-pl-expired-target")){var t=document.querySelector(box.getAttribute("data-pl-expired-target"));if(t)t.textContent=expired;}return;}
        var dd=Math.floor(diff/86400000),hh=Math.floor(diff%86400000/3600000),mm=Math.floor(diff%3600000/60000),ss=Math.floor(diff%60000/1000);
        if(d)d.textContent=pad(dd);if(h)h.textContent=pad(hh);if(m)m.textContent=pad(mm);if(s)s.textContent=pad(ss);
        // mirror to any linked mini timers
        var mir=box.getAttribute("data-pl-mirror");
        if(mir){var el=document.querySelector(mir);if(el)el.textContent=(dd>0?dd+"d ":"")+pad(hh)+":"+pad(mm)+":"+pad(ss);}
        setTimeout(tick,1000);
      }
      tick();
    });
  }

  /* Confetti (used by quiz/poll). Exposed globally. */
  window.plConfetti=function(anchor){
    if(window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches)return;
    var colors=["#6C4AB6","#E76F51","#D4A373","#FF6B35"];
    var r=anchor?anchor.getBoundingClientRect():{left:window.innerWidth/2,width:0};
    for(var i=0;i<22;i++){var c=document.createElement("span");c.className="pl-confetti";
      c.style.cssText="position:fixed;width:9px;height:13px;top:-20px;z-index:9999;pointer-events:none;animation:pl-fall linear forwards;";
      c.style.left=(r.left+r.width/2+(Math.random()*220-110))+"px";c.style.background=colors[i%colors.length];
      c.style.animationDuration=(1.3+Math.random()*1.3)+"s";c.style.borderRadius=Math.random()>.5?"50%":"2px";
      document.body.appendChild(c);(function(el){setTimeout(function(){el.remove();},2800);})(c);}
  };
  if(!document.getElementById("pl-fall-kf")){
    var st=document.createElement("style");st.id="pl-fall-kf";
    st.textContent="@keyframes pl-fall{to{transform:translateY(105vh) rotate(720deg);opacity:.2;}}";
    document.head.appendChild(st);
  }

  function boot(){initReveal();initCountdowns();}
  if(document.readyState!=="loading")boot();else document.addEventListener("DOMContentLoaded",boot);
  // re-run in Shopify theme editor when sections are added/reordered
  document.addEventListener("shopify:section:load",boot);
  window.plSaleBoot=boot;
})();
